import { render, staticRenderFns } from "./ClienteChart.vue?vue&type=template&id=f8e8cf44&"
import script from "./ClienteChart.vue?vue&type=script&lang=js&"
export * from "./ClienteChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports